import { render } from "./Metrics.vue?vue&type=template&id=07a99e02&scoped=true"
import script from "./Metrics.vue?vue&type=script&lang=js"
export * from "./Metrics.vue?vue&type=script&lang=js"

import "./Metrics.vue?vue&type=style&index=0&id=07a99e02&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/test-cx/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07a99e02"]])

export default __exports__